import { FulfStatus, PhysicalFulfillment } from '../graphql';

export enum FulfillmentStatus {
	Failed = 'Failed',
	Completed = 'Completed',
	PendingExpired = 'PendingExpired',
	Pending = 'Pending',
	Ordered = 'Ordered',
	Queued = 'Queued',
	Available = 'Available',
	Never = 'Never',
}

export const calculateFulfStatus = (
	fulf: PhysicalFulfillment,
	isPast: (date: Date) => boolean = dateIsPast
): FulfillmentStatus => {
	const certExpireDate = fulf.cert?.expireDate;

	/**
	 * Note: The logic below is a bit redundant, but it is for clarity/readability/maintainability.
	 * Failed - status is failed
	 * Completed - status is ok
	 * Ordered - exportOkDate is not null and exported is not null
	 * Queued - exportOkDate is not null and exported is null
	 * Pending - pendingDmgr or pendingRequeue is true AND cert is not expired
	 * PendingExpired - pendingDmgr or pendingRequeue is true AND cert is expired
	 * Never - exportOkDate is null AND pendingDmgr and pendingRequeue are false
	 * Available - Everything else
	 */
	if (fulf.status === FulfStatus.Failed) {
		return FulfillmentStatus.Failed;
	} else if (fulf.status === FulfStatus.Ok) {
		return FulfillmentStatus.Completed;
	} else if (fulf.exportOkDate && fulf.exported) {
		return FulfillmentStatus.Ordered;
	} else if (fulf.exportOkDate && !fulf.exported) {
		return FulfillmentStatus.Queued;
	} else if (
		(fulf.pendingDmgr || fulf.pendingRequeue) &&
		certExpireDate &&
		isPast(certExpireDate)
	) {
		return FulfillmentStatus.PendingExpired;
	} else if (fulf.pendingDmgr || fulf.pendingRequeue) {
		return FulfillmentStatus.Pending;
	} else if (!fulf.exportOkDate) {
		return FulfillmentStatus.Never;
	} else {
		return FulfillmentStatus.Available;
	}
};

const dateIsPast = (targetDate: Date) => new Date(targetDate) < new Date();

export const fulfillmentStatusSort: { [key in FulfillmentStatus]: number } = {
	Pending: 0,
	Available: 1,
	Failed: 2,
	Queued: 3,
	Ordered: 4,
	Completed: 5,
	PendingExpired: 6,
	Never: 7,
};
